/**
 * 🔧 EDIT MODE TOOLBAR
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Toolbar shown in EDIT mode with Save/Cancel actions
 * Enforces Executive Immutability: explicit confirmation required
 */

import React from 'react';
import { Save, X, AlertCircle } from 'lucide-react';

interface EditModeToolbarProps {
  hasChanges: boolean;
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

const EditModeToolbar: React.FC<EditModeToolbarProps> = ({
  hasChanges,
  onSave,
  onCancel,
  isSaving = false
}) => {
  return (
    <div className="edit-mode-toolbar">
      <div className="edit-mode-toolbar-content">
        <div className="edit-mode-indicator">
          <AlertCircle size={20} />
          <span>Editing Dashboard</span>
          {hasChanges && <span className="changes-badge">Unsaved changes</span>}
        </div>

        <div className="edit-mode-actions">
          <button
            className="btn-secondary"
            onClick={onCancel}
            disabled={isSaving}
          >
            <X size={18} />
            Cancel
          </button>
          
          <button
            className="btn-primary"
            onClick={onSave}
            disabled={!hasChanges || isSaving}
          >
            <Save size={18} />
            {isSaving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      {hasChanges && (
        <div className="edit-mode-warning">
          ⚠️ Changes will be optimized by the system when saved. Layout may adjust.
        </div>
      )}
    </div>
  );
};

export default EditModeToolbar;
